import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const TabsContext = /*#__PURE__*/createContext(undefined);
export const TabsProvider = ({
  tabsSectionStyleOverrides = {},
  tabsLinkStyleOverrides = {},
  tabsTabStyleOverrides = {},
  children
}) => {
  return /*#__PURE__*/_jsx(TabsContext.Provider, {
    value: {
      tabsSectionStyleOverrides,
      tabsLinkStyleOverrides,
      tabsTabStyleOverrides
    },
    children: children
  });
};

/**
 * Provides the context for the `Tabs` component.
 * Note: The context is only available when the `Tabs` component is rendered as an ancestor.
 * @returns TabsContext - The context for the `Tabs` component.
 * @returns TabsContext.tabsSectionStyleOverrides - Style overrides to be applied to the `Section` component.
 * @returns TabsContext.tabsLinkStyleOverrides - Style overrides to be applied to the `Link` component.
 * @returns TabsContext.tabsTabStyleOverrides - Style overrides to be applied to the `Tab` component.
 */
export const useTabsContext = () => {
  return useContext(TabsContext);
};